// extracted by mini-css-extract-plugin
export var fullHeightState = "_4v-7";
export var headerCell = "_4v-1";
export var loadingStateCell = "_4v-4";
export var rowWrapper = "_4v-3";
export var standaloneTable = "_4v-8";
export var standaloneTableWithBodyFill = "_4v-9";
export var stateCell = "_4v-5";
export var table = "_4v-0";
export var tableBodyFiller = "_4v-6";
export var white = "_4v-2";